import { LOYALTY_ERROR, SET_LOYALTY } from '../types/LoyaltyTypes';

const initialState = {
  category: '',
  loading: true,
  error: false,
};

const loyaltyReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOYALTY:
      return {
        ...state,
        category: action.category,
        loading: false,
        error: false,
      };
    case LOYALTY_ERROR:
      return {
        ...state,
        category: 'Sin Categoría',
        loading: false,
        error: false,
      };
    default:
      return state;
  }
};

export default loyaltyReducer;
